import { Algorithm, AlgorithmVersion, Inference } from '../../types';
import { publicApi } from '../../config/AxiosService';
import { algorithmTypes } from '../../config/AlgorithmTypes';

export const getLatestAlgorithmVersionPublic = async (algorithmId: string): Promise<AlgorithmVersion> => {
  const response = await publicApi.get(`/algorithms/${algorithmId}/version/latest`);
  return response.data;
};

export const getAlgorithmPublic = async (algorithmId: string): Promise<undefined | Algorithm> => {
  const algorithmVersion = await getLatestAlgorithmVersionPublic(algorithmId);
  if (!algorithmVersion) {
    return undefined;
  }
  const algorithm = algorithmVersion.algorithm;
  if (!algorithm) return undefined;

  const algorithmType = algorithmTypes.find((type) => type.name === algorithm.name);
  return { ...algorithmType, ...algorithm };
};

export const getInferencePublic = async (inferenceId: string): Promise<Inference> => {
  const response = await publicApi.get('/inference-files/' + inferenceId);
  return response.data;
};
